import type { Metadata } from "next";
import { SiteFooter, SiteNav } from "@/components/site-chrome";

export const metadata: Metadata = { title: "Privacy Policy — EasyShot" };

const SECTIONS: { h: string; p: string }[] = [
  {
    h: "1. What we collect",
    p: "Account details (email), the product links, text and images you submit, the scripts and videos generated from them, and usage data (pages visited, features used). Payment details are handled by our payment processor and never stored on our servers.",
  },
  {
    h: "2. How we use it",
    p: "To run the service: extracting product data, generating scripts, rendering videos, and showing your project library. We also use aggregate usage data to improve the product.",
  },
  {
    h: "3. Third-party processors",
    p: "Product text is sent to AI model providers to generate scripts, and scripts are sent to our video rendering provider to produce avatar videos. Generated files are stored with our cloud storage provider. These processors act under contract and may not use your content to train their models where opt-outs are available — we enable them.",
  },
  {
    h: "4. Retention and deletion",
    p: "Projects and videos are kept until you delete them or close your account. Deleting a project removes its videos from our storage within 30 days. You can request full account deletion at any time.",
  },
  {
    h: "5. Cookies",
    p: "We use only essential cookies for sign-in and preferences. Analytics, if enabled, is cookieless and aggregate.",
  },
  {
    h: "6. Your rights",
    p: "Depending on your region (GDPR, CCPA), you may request access, correction, export or deletion of your data. Contact us and we will respond within 30 days.",
  },
  {
    h: "7. Contact",
    p: "Questions about this policy: privacy@easyshot.ai.",
  },
];

export default function PrivacyPage() {
  return (
    <>
      <SiteNav />
      <main className="mx-auto w-full max-w-3xl px-5 py-16">
        <h1 className="text-3xl font-semibold tracking-tight">Privacy Policy</h1>
        <p className="mt-2 text-sm text-muted">Effective date: August 15, 2026</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.h}>
              <h2 className="text-lg font-semibold">{s.h}</h2>
              <p className="mt-2 text-sm leading-7 text-muted">{s.p}</p>
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
